export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EditOrderModal.vue?vue&type=template&id=2b2f357c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/EditOrderModal.vue?vue&type=template&id=2b2f357c&scoped=true
// module id = 2347
// module chunks = 31